/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2021
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
import ObjectFactory from './ObjectFactory';
import ModuleUtils from './ModuleUtils';
//@import BaseMoserObject (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectFactory (runtime) // new
//@import com/ibm/bi/platform/moser/client/utils/ModuleUtils (runtime) // getIdGenerator

/**
 * A generic utility to provide POJO manipulation behavior
 */
export default class GenericClientUtils extends BaseMoserObject{

	objectFactory = null;



	/**
	 * @return {ObjectFactory}  the objectFactory
	 */
	getObjectFactory() {
		return this.objectFactory;
	}

	/**
	 * @param {ObjectFactory} objectFactory  the objectFactory to set
	 */
	setObjectFactory(objectFactory) {
		this.objectFactory = objectFactory;
	}

	constructor() {
		super();
		this.objectFactory = new ObjectFactory();
	}

	/**
	 * Set property of the object to the value provided. If property exists, change to new value. Return old value or null, if no such property was set before
	 * @param {BaseObjectType} object base object to set a property to
	 * @param {String} name property name
	 * @param {String} value property value
	 */
	setProperty(object, name, value) {
		var oldValue;
		for (var __i_enFor0 = 0, __exp_enFor0 = object.getProperty(), __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var pair = __exp_enFor0[__i_enFor0];
			if (pair.getName() == name) {
				oldValue = pair.getValue();
				pair.setValue(value);
				return oldValue;
			}
		}
		var pair = this.objectFactory.createPropertyType();
		pair.setName(name);
		pair.setValue(value);
		object.addProperty(pair);
		return oldValue;
	}

	/**
	 * Return value of the property with the given name, or null of property does not exist
	 * @param {BaseObjectType} object object that owns the property
	 * @param {String} name property name
	 * @return {String}  value of the property with the given name, or null of property does not exist
	 */
	getPropertyValue(object, name) {
		for (var __i_enFor0 = 0, __exp_enFor0 = object.getProperty(), __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var pair = __exp_enFor0[__i_enFor0];
			if (pair.getName() == name) {
				return pair.getValue();
			}
		}
		return null;
	}

	/**
	 * Remove property with the given name and return removed object or null if none exist
	 * @param {BaseObjectType} object object with the property
	 * @param {String} name name of the property to be removed
	 * @return {PropertyType}  property with the given name and return removed object or null if none exist
	 */
	removeProperty(object, name) {
		for (var __i_enFor0 = 0, __exp_enFor0 = object.getProperty(), __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var pair = __exp_enFor0[__i_enFor0];
			if (pair.getName() == name) {
				object.removeProperty(pair);
				return pair;
			}
		}
		return null;
	}

	/**
	 * Generic method to perform batch cloning of the originals, adjusting their ids and returning a collection of clones with unique IDs
	 * @param {ObjectType} scope parental object within who's scope the new IDs must be unique
	 * @param {Array} objects original object to be cloned
	 * @return {Array}  cloned objects with unique IDs
	 * @throws {CloneNotSupportedException} CloneNotSupportedException
	 */
	createCopies(scope, objects) {
		var idman = this._getIdGenerator(scope);
		var clones = [];
		for (var __i_enFor0 = 0, __exp_enFor0 = objects, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var object = __exp_enFor0[__i_enFor0];
			var clone = object.clone();
			idman.generateId(clone);
			clones.push(clone);
		}
		return clones;
	}

	/**
	 * Generic method to create a clone of the original, generate unique id and return  newly created clone
	 * @param {ObjectType} scope parental object within who's scope the new IDs must be unique
	 * @param {ObjectType} object original object to be cloned
	 * @return {ObjectType}  cloned object with a unique ID
	 * @throws {CloneNotSupportedException} CloneNotSupportedException
	 */
	createCopy(scope, object) {
		var clone = object.clone();
		this._getIdGenerator(scope).generateId(clone);
		return clone;
	}

	/**
	 * @param {ObjectType} scope
	 * @return {IdGenerator}
	 */
	_getIdGenerator(scope) {
		return ModuleUtils.getIdGenerator(scope);
	}
}


// WEBPACK FOOTER //
// ./src/generated/GenericClientUtils.js